export default __webpack_public_path__ + "static/media/LinkedIn.0015540c.svg";